export const buildQueryParams = (page, query) => {
  const params = new URLSearchParams({ page });
  if (query?.trim()) params.append("name", query.trim());
  return params.toString();
};
